import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { deleteSpace } from '../lib/spaces';
import { spacesKeys } from '../query-keys/spaces';
import { DeleteSpacePayload } from '../types/payload/delete-space.payload';

export const useDeleteSpace = (onSuccess?: () => void) => {
  const { t } = useTranslation(['spaces', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: DeleteSpacePayload) => deleteSpace(payload),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: spacesKeys.lists(),
        });
      });
      toast.success(t('spaces:common.deleteSpaceDialog.success'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
